import { Button, Modal, Stack, TextInput } from "@mantine/core"
import { DatePickerInput } from "@mantine/dates"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { useCreateVisit, useUpdateVisit } from "../hooks/use-visits"

interface MSaveVisitProps {
  opened: boolean
  onClose: () => void
  editingVisit: any | null
}

const emptyVisit = {
  medico: "",
  fecha: "",
  motivo: "",
  observaciones: ""
}

export function MSaveVisit({ opened, onClose, editingVisit }: MSaveVisitProps) {
  const [visit, setVisit] = useState<typeof emptyVisit>(emptyVisit)
  const createVisitMutation = useCreateVisit()
  const updateVisitMutation = useUpdateVisit()

  useEffect(() => {
    if (editingVisit) {
      setVisit({
        medico: editingVisit.medico || "",
        fecha: editingVisit.fecha || "",
        motivo: editingVisit.motivo || "",
        observaciones: editingVisit.observaciones || ""
      })
    } else {
      setVisit(emptyVisit)
    }
  }, [editingVisit, opened])

  const handleSave = async () => {
    if (editingVisit) {
      await updateVisitMutation.mutateAsync({ id: editingVisit.id, visitData: visit })
    } else {
      await createVisitMutation.mutateAsync(visit)
    }
    onClose()
  }

  return (
    <Modal opened={opened} onClose={onClose} title={editingVisit ? "Editar Visita" : "Agregar Nueva Visita"} centered>
      <Stack>
        <TextInput label="Médico" placeholder="Nombre del médico" value={visit.medico} onChange={(e) => setVisit({ ...visit, medico: e.target.value })} />
        <DatePickerInput label="Fecha" placeholder="Seleccione fecha" value={visit.fecha ? dayjs(visit.fecha).toDate() : null} onChange={(val) => setVisit({ ...visit, fecha: val ? dayjs(val).format("YYYY-MM-DD") : "" })} />
        <TextInput label="Motivo" placeholder="Motivo de la visita" value={visit.motivo} onChange={(e) => setVisit({ ...visit, motivo: e.target.value })} />
        <TextInput label="Observaciones" placeholder="Observaciones" value={visit.observaciones} onChange={(e) => setVisit({ ...visit, observaciones: e.target.value })} />
        <Button onClick={handleSave} loading={createVisitMutation.isPending || updateVisitMutation.isPending}>
          Guardar
        </Button>
      </Stack>
    </Modal>
  )
}
